module.exports = __webpack_public_path__ + "img/lastsupper.33247ef2.jpg";